import React from 'react';
import { unescape } from 'lodash';

import style from '../index.module.css';

import Email from '../../../static/images/email.svg';
import Phone from '../../../static/images/phone.svg';
import Placeholder from '../../../static/images/placeholder.svg';

type MemberCardProps = {
    details?: string;
    email?: string;
    image?: string;
    imageAltText?: string;
    phoneNumber?: string;
    promoType: string;
    title?: string;
    type?: string;
    url?: string;
};

const MemberCard = ({
    details,
    email,
    image,
    imageAltText,
    phoneNumber,
    promoType,
    title,
    type,
    url,
}: MemberCardProps) => {
    return (
        <div className={style.cardPromo} data-type={promoType}>
            <div className={`${style.imageContainer} ${style.circle}`}>
                {/* Remove tabindex so users don't have to tab through cards twice (they are both the same link) */}
                <a href={url} tabIndex={-1}>
                    <img src={image ? image : Placeholder} alt={imageAltText ? imageAltText : unescape(title)} />
                </a>
            </div>

            <div className="info">
                <h3 className={style.memberName}>
                    {url ? <a href={url}>{unescape(title)}</a> : <span>{unescape(title)}</span>}
                </h3>

                {details && <div className={style.memberRole}>{unescape(details)}</div>}

                {email && (
                    <div className={style.memberMail}>
                        <a href={`mailto:${email}`}>
                            <Email />
                            {email}
                        </a>
                    </div>
                )}

                {phoneNumber && (
                    <div className={style.memberPhone}>
                        <a href={`tel:${phoneNumber}`}>
                            <Phone />
                            {phoneNumber}
                        </a>
                    </div>
                )}

                <div className={style.status}>{type}</div>
            </div>
        </div>
    );
};

export default MemberCard;
